const FormSelect = ({ options = [], value = null, onChange = null }) => {
  return (
    <div className="mt-1 block">
      <select
        defaultValue={value}
        onChange={onChange}
        className="block w-full rounded border-gray-300 bg-transparent py-0.5 pl-2 text-sm shadow-sm focus:border-primary-200 focus:ring focus:ring-primary-100 focus:ring-opacity-50"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    </div>
  )
}
export default FormSelect
